const topicTags = [
  { name: '原创视频', count: '12.8万', icon: 'ri-movie-line' },
  { name: '社区热点', count: '9.6万', icon: 'ri-fire-line' },
  { name: '创作教程', count: '5.4万', icon: 'ri-book-open-line' },
  { name: '论坛精选', count: '8.2万', icon: 'ri-chat-1-line' },
  { name: '新人报到', count: '3.1万', icon: 'ri-user-heart-line' },
  { name: '作品分享', count: '7.5万', icon: 'ri-share-forward-line' },
  { name: '技术交流', count: '4.8万', icon: 'ri-code-line' },
  { name: '活动专区', count: '2.6万', icon: 'ri-calendar-event-line' },
  { name: '海角社', count: '1.9万', icon: 'ri-star-line' },
];

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            话题广场
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-md mx-auto">
            探索海角社区最热门的话题标签
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicTags.map((tag) => (
            <a
              key={tag.name}
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 px-4 py-2.5 bg-background-100 rounded-full border border-background-200/70 hover:border-primary-200 hover:bg-primary-50 transition-all duration-200 cursor-pointer group"
            >
              <i className={`${tag.icon} text-sm text-primary-500 group-hover:text-primary-600`}></i>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                {tag.name}
              </span>
              <span className="text-xs text-foreground-400 bg-background-200/70 px-1.5 py-0.5 rounded-full">
                {tag.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}